import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export type TSection =
  | 'info'
  | 'priceHistory'
  | 'deliveryTime'
  | 'lastDeals'
  | 'marketDepth';

type TItem = {
  label: string;
  section: TSection;
};

@Injectable({
  providedIn: 'root',
})
export class BasisDetailsService {
  constructor() {}

  private items: TItem[] = [
    {
      label: 'Информация о базисе',
      section: 'info',
    },
    {
      label: 'История изменения цены',
      section: 'priceHistory',
    },
    {
      label: 'Биржевой стакан',
      section: 'marketDepth',
    },
    {
      label: 'Время в пути',
      section: 'deliveryTime',
    },
    {
      label: 'Последние сделки',
      section: 'lastDeals',
    },
  ];

  getItems() {
    return this.items.slice();
  }

  private currentItemSubject$ = new BehaviorSubject(this.items[1].section);
  currentItem$ = this.currentItemSubject$.asObservable();
  setCurrentItem(section: TSection) {
    this.currentItemSubject$.next(section as TSection);
  }
}
